module.exports = ".itemmenu:hover{\n    background: #f9f9f9;\n  }\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/agregar-equipo/agregar-equipo.component.css
// module id = ./src/app/modulos/agregar-equipo/agregar-equipo.component.css
// module chunks = main